import { render } from "./Animation.vue?vue&type=template&id=3c0d85fe"
import script from "./Animation.vue?vue&type=script&lang=js"
export * from "./Animation.vue?vue&type=script&lang=js"

import "./Animation.vue?vue&type=style&index=0&id=3c0d85fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__